"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMovingNodes = exports.shouldHideNode = void 0;
var types_1 = require("../types");
var shouldHideNode = function (node) {
    var editState = node.editState, nodeType = node.nodeType;
    if (!editState) {
        return false;
    }
    switch (editState) {
        case types_1.NodeMoveState.Move:
            return nodeType !== types_1.NodeType.Location;
        case types_1.NodeMoveState.MoveBranch:
            return true;
        default:
            return false;
    }
};
exports.shouldHideNode = shouldHideNode;
function isMovingNodes(state) {
    return !!(state === null || state === void 0 ? void 0 : state.selectedNodeId) && state.nodeMoveState !== types_1.NodeMoveState.None;
}
exports.isMovingNodes = isMovingNodes;
